import { CRM } from "@/components/atomic-crm/root/CRM";
import { parabonConfiguration } from "@/parabon/configuration";

/**
 * Application entry point
 *
 * The domain configuration (pipeline stages, plans, property types, task
 * types, branding, currency) lives in `src/parabon/configuration.ts`.
 *
 * Note: these props only *seed* the configuration store on first load — once
 * seeded, the Settings page is the source of truth. Clear local storage to
 * pick up changes made here.
 */
const App = () => <CRM {...parabonConfiguration} disableTelemetry />;

export default App;
